const Section_Title = ({title}) => {
  return (
    <h2 className="py-12 text-xl text-teal-900 sm:text-2xl md:text-3xl font-title">
      {title}
    </h2>
  );
};

export default Section_Title;
